import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  initialize() {
    this.resetAndScroll()
  }

  // <%= form_with ..., html: { 'data-controller': 'messages', 'data-action': 'turbo:submit-end->messages#resetAndScroll' } do |f| %>
  resetAndScroll() {
    this.element.reset()
    const container = document.querySelector(this.data.get('containerId'))
    if (container) container.scrollTo({ top: container.scrollHeight, behavior: 'smooth' })
  }
}
